
angular.module('bmsApp.crm.prospect', [
	'ui.router'
])
	.config([
		'$stateProvider', 'BMSPermission', function config(
			$stateProvider,
			BMSPermission
			) {

			$stateProvider

				.state('main.crm.prospect', {
					abstract: true,
					data: {
						authorisedRoles: [BMSPermission.CRM]
					}
				})
				
				.state('main.crm.prospect.index', {
					url: '/prospects',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/prospect/templates/ProspectIndex.html",
							controller: 'ProspectIndexCtrl'
						},
						'side@main.crm': {
							templateUrl: "ng/crm/prospect/templates/ProspectIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Prospects'}
				})
				
				.state('main.crm.prospect.index.view', {
					url: '^/crm/prospect/{prospectId:int}',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/prospect/templates/ProspectView.html",
							controller: 'ProspectViewCtrl'
						}
					},
					ncyBreadcrumb: {label: '{{ prospect.opportunity_name }}'}
				})

				.state('main.crm.prospect.index.create', {
					url: '^/crm/prospect/add/{contactId}',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/prospect/templates/ProspectSave.html",
							controller: 'ProspectSaveCtrl',
							params: {
								contactId: {
									value: null,
									squash: true
								}
							}
						}
					},
					ncyBreadcrumb: {label: 'Add Prospect'}
				})

				.state('main.crm.prospect.index.view.update', {
					url: '^/crm/prospect/edit/{prospectId:int}',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/prospect/templates/ProspectSave.html",
							controller: 'ProspectSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Edit Prospect'}
				})

				;
				
		}]);
